import React from "react";
import { useNavigate } from "react-router-dom";
import "./FuntelliMeCard.css";
export default function FuntelliMeCard() {
  const navigate = useNavigate();
  const handleStartFuntelliMe = () => {
    navigate("/funtellime/mode-selection");
  };
  return (
    <div className="funtellime-card">
      <h2>FuntelliMe (Low)</h2>
      <p>Casual, short encounters with Dynamic Profiles that highlight mutual interests.</p>
      <button className="funtellime-btn" onClick={handleStartFuntelliMe}>Start FuntelliMe</button>
      {/* <button className="funtellime-btn" style={{ marginLeft: 12 }} disabled>Join Queue</button> */}
      <div style={{ marginTop: 12 }}>
        <span className="beta-badge">BETA</span>
      </div>
    </div>
  );
}
